// Initialize BoosterTheme object if it doesn't exist
window.BoosterTheme = window.BoosterTheme || {};
window.BoosterTheme.cart = window.BoosterTheme.cart || {};

// Function to update button states based on date selection
BoosterTheme.cart.updateButtonStates = function(hasDate) {
  const checkoutButton = document.querySelector('[data-checkout-button]');
  const viewCartButton = document.querySelector('[data-view-cart-button]');
  
  if (checkoutButton) {
    if (hasDate) {
      checkoutButton.removeAttribute('disabled');
    } else {
      checkoutButton.setAttribute('disabled', 'disabled');
    }
  }
  
  if (viewCartButton) {
    if (hasDate) {
      viewCartButton.removeAttribute('disabled');
    } else {
      viewCartButton.setAttribute('disabled', 'disabled');
    }
  }
};

// Add the cart date picker functionality
BoosterTheme.cart.updateLineItemProperty = async function(event, variantId, propertyName) {
    const dateValue = event.target.value;
    
    try {
      const formData = {
        'id': variantId,
        'properties': {
          [propertyName]: dateValue
        }
      };
  
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      if (!response.ok) throw new Error('Network response was not ok');
      
      // Update button states based on date selection
      BoosterTheme.cart.updateButtonStates(!!dateValue);
      
      // Refresh the cart
      BoosterTheme.cart.getCart();
      
    } catch (error) {
      console.error('Error updating date:', error);
      // Optionally show an error message to the user
    }
};

// Initialize button states on page load
document.addEventListener('DOMContentLoaded', function() {
  const datePicker = document.querySelector('[data-datepicker]');
  if (datePicker) {
    BoosterTheme.cart.updateButtonStates(!!datePicker.value);
  }
}); 